/**
 * Publisher Service API Client
 *
 * Axios instance configured for Publisher Service
 * Handles publisher-specific operations, books, and metadata
 */

import { API_CONFIG } from '../config';
import { createApiClient } from './api-client-factory';

/**
 * Publisher API Client
 * Handles book management, metadata uploads, and publisher dashboard
 */
const publisherClient = createApiClient({
  baseURL: API_CONFIG.PUBLISHER.BASE_URL,
  timeout: API_CONFIG.PUBLISHER.TIMEOUT,
  withRefreshToken: false, // TODO: Enable when backend supports refresh token
  refreshEndpoint: '/auth/refresh',
});

export default publisherClient;
